import { BaseDto } from './base.dto';
import { PrintTemplateDto } from './printTemplate.dto';

export enum TemplateSectionPrintType{
    TEXT_LINE,
    LINE_SEPARATOR,
    TABLE,
    BARCODE,
    QR_CODE
}

export class PrintTemplateSectionDto extends BaseDto{

    name: string;


    printTemplate: PrintTemplateDto;

    printType: TemplateSectionPrintType;


    printTypeMetadata: any;

    formattingMetadata: any;

    enabled: boolean;
    
    printEnabledDefault: boolean;

    sequence: number;
}